import { ListItemButton, ListItemText } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Fragment, useCallback } from 'react';
import { AddressSearchListRowType } from './AddressSearchList';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

export type AddressSearchListItemType = {
  row: AddressSearchListRowType;
  searchValue: string;
  onAddressSelect: (id: string) => void;
};

export const AddressSearchListItem: React.VFC<AddressSearchListItemType> = ({
  row,
  searchValue,
  onAddressSelect
}) => {
  const { classes } = useAddressListStyles();
  const { address, id, addressCityState } = row;

  const renderAddressHighlight = useCallback((address: string) => {
    const matches = match(address, searchValue);
    const parts = parse(address, matches);

    return parts.map(({ highlight, text }, i) => (
      <Fragment key={i}>
        {highlight ? <span className={classes.highlight}>{text}</span> : text}
      </Fragment>
    ));
  }, [ searchValue, classes.highlight ]);

  return (
    <ListItemButton
      onClick={() => onAddressSelect(id)}
      className={classes.listItem}
      divider
    >
      <ListItemText
        primary={renderAddressHighlight(address)}
        primaryTypographyProps={{
          className: classes.addressSpan
        }}
        secondary={addressCityState}
        secondaryTypographyProps={{
          variant: 'body2',
          className: classes.addressSpan2
        }}
      />
    </ListItemButton>
  );
};

const useAddressListStyles = makeStyles()((theme) => ({
  listItem: {
    padding: theme.spacing(0, 2),
  },
  addressSpan: {
    display: 'block',
    fontSize: '1rem',
    lineHeight: '1.5rem'
  },
  addressSpan2: {
    display: 'block',
    fontSize: '1rem',
    lineHeight: '1.25rem'
  },
  highlight: {
    fontWeight: 600
  }
}));
